module.exports = __webpack_public_path__ + "img/ticket-receipt.799a65eb.png";